import { LINK } from '@constants';
import { BottomBarHome, Point2, UserLine, ViewingMenu } from '@viewup/ui';

// gaLabel 은 GA 셀렉터가 잡는 클래스(`ga-link-bottombar-<gaLabel>`)의 일부다 — 화면 라벨(title)이 바뀌어도 그대로 둔다.
export const bottomBarMenu = [
  {
    gaLabel: '홈',
    icon: BottomBarHome,
    link: LINK.HOME,
    requireLogin: false,
    title: '홈',
  },
  {
    gaLabel: '뷰잉하기',
    icon: ViewingMenu,
    link: LINK.VIEWING,
    requireLogin: false,
    title: '뷰업하기',
  },
  {
    gaLabel: '뷰잉머니',
    icon: Point2,
    link: LINK.VIEWING_MONEY,
    requireLogin: true,
    title: '뷰업 포인트',
  },
  {
    gaLabel: '마이뷰업',
    icon: UserLine,
    link: LINK.MY_VIEWUP,
    requireLogin: false,
    title: '마이뷰업',
  },
];
